import React from "react";
import "./SortBar.css";

export default function SortBar({ sort, view, setView, setSort }) {
  return (
    <div className="sortbar">
      <div className="sort-left">
        <label>Sort by</label>
      </div>
      <div className="sort-dropdown">
        <select value={sort} onChange={(e) => setSort(e.target.value)}>
          <option value="newest">Newest</option>
          <option value="price_asc">Price: Low to High</option>
          <option value="price_desc">Price: High to Low</option>
        </select>
      </div>

      <div className="sort-right">
        <button
          onClick={() => setView("grid")}
          className={view === "grid" ? "active" : ""}
        >
          Grid
        </button>
        <button
          onClick={() => setView("list")}
          className={view === "list" ? "active" : ""}
        >
          List
        </button>
      </div>
    </div>
  );
}
